
<div id="background_menu" (click)="this.closeMenu()"></div>

<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start"> 
            <ion-button (click)="this.goBack()" [style]="{'opacity': (this.navigationService.canGoBack() === false ? 0 : 1)}">
                <ion-icon  slot="icon-only" name="arrow-back-outline"></ion-icon>
            </ion-button> 
        </ion-buttons>
        
        <ion-buttons slot="end"> 
            @if(this.isOpen){
                <ion-button (click)="this.closeMenu()">
                    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                </ion-button>
            }
            @else{
                <ion-button (click)="this.openMenu()">
                    <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
                </ion-button>
            }
        </ion-buttons>
        
        <ion-title class="menu_app_name" (click)="this.goToHome()">
            <img src="./assets/imgs/logo_marving_menu.jpg" [title]="this.agencyData.appName"/>
        </ion-title>
           
    </ion-toolbar>
</ion-header>

<ion-content id="content_menu">
    
    <div id="btn_toggle_reduce_menu">            
        @if(this.isReduced){
            <ion-button (click)="this.extendMenu()" fill="clear">
                <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
            </ion-button>
        }
        @else{
            <ion-button (click)="this.reduceMenu()" fill="clear">
                <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
            </ion-button>
        }        
    </div>
    
    <div class="menu_app_name" (click)="this.goToHome()">
        <img src="./assets/imgs/logo_marving_menu.jpg" [title]="this.agencyData.appName"/>
    </div>
    <div class="menu_app_name_reduce" (click)="this.goToHome()">
        <img src="./assets/imgs/logo_marving_menu_short.jpg" [title]="this.agencyData.appName"/>
    </div>
    
    @if(this.loggedUserService.loggedUser !== null){
        <ion-avatar id="avatar_user_logged" title="{{this.loggedUserService.loggedUser.fullName()}}">{{this.getInitials()}}</ion-avatar>
    }
    
    <ion-list lines="none">
        @for (item of this.menuService.itemsMenu; track item.url) {
            <ion-item (click)="this.goToPage(item.url)" button>
                <ion-icon [name]="item.icon" slot="start" class="menu_icon" title="{{item.title | translate}}"></ion-icon>
                <ion-label>{{item.title | translate}}</ion-label>
            </ion-item>
        }
    </ion-list>
    
    
    <ion-list lines="none" id="menu_footer">
        @if(this.loggedUserService.loggedUser !== null){
        
            <!--
            A MODIFIER - Créer la gestion des alertes
            @if(this.nbAlerts > 0){
                <ion-item  id="item_alerts_unread" (click)="this.showAlerts()" button>
                    <ion-icon name="mail-unread-outline" slot="start" class="menu_icon" title="{{this.translateService.instant('MENU_ALERTS_UNREAD').replace('#nb_alerts#',this.nbAlerts)}}"></ion-icon>
                    <ion-label>{{this.translateService.instant('MENU_ALERTS_UNREAD').replace('#nb_alerts#',this.nbAlerts)}}</ion-label>
                </ion-item>
            }
            -->
            <!--
            <ion-item (click)="this.synchroService.synchronize()" button>
                <ion-icon name="sync-outline" slot="start" class="menu_icon" title="{{'SYNCHRONIZE' | translate}}"></ion-icon>
                <ion-label>
                    {{'SYNCHRONIZE' | translate}}
                    <br><ion-note title="{{'DERNIERE_SYNCHRO' | translate}}">{{this.getDateSynchro()}}</ion-note>
                </ion-label>                
            </ion-item>
            -->
            <ion-item (click)="this.logoutOut()" button>
                <ion-icon name="exit-outline" slot="start" class="menu_icon" title="{{'LOGOUT' | translate}}"></ion-icon>
                <ion-label>{{'LOGOUT' | translate}}</ion-label>
            </ion-item>
        }
    </ion-list>
    
</ion-content>
